// @ts-check

/** @type import("../../types/themes").TokensGenerator  */
const tokens = (palette, aliases) => ({
  action: {
    default: {
      background: aliases.background.default,
      backgroundDisabled: aliases.neutral["100"],
      backgroundHover: aliases.background.strong,
      bullet: aliases.neutral["200"],
      bulletHover: aliases.neutral["300"],
      marker: aliases.neutral["400"],
      text: aliases.text.default,
    },
    selected: {
      background: aliases.highlight["200"],
      backgroundDisabled: aliases.highlight["200"],
      backgroundHover: aliases.highlight["300"],
      bullet: aliases.highlight["300"],
      bulletHover: aliases.highlight["400"],
      marker: aliases.text.highlight,
      text: aliases.text.highlight,
    },
  },
  box: {
    default: {
      background: aliases.background.default,
      border: aliases.border.default,
      text: aliases.text.default,
      icon: aliases.text.default,
    },
    alternate: {
      background: aliases.background.strong,
      border: aliases.border.default,
      text: aliases.neutral["800"],
      icon: aliases.text.default,
    },
    strong: {
      background: aliases.background.default,
      border: aliases.border.strong,
      text: aliases.text.default,
      icon: aliases.text.default,
    },
    highlight: {
      background: aliases.highlight["100"],
      border: aliases.highlight.default,
      text: aliases.text.default,
      icon: aliases.text.highlight,
    },
    success: {
      background: aliases.success["100"],
      border: aliases.success.default,
      text: aliases.text.default,
      icon: aliases.text.success,
    },
    warning: {
      background: aliases.warning["100"],
      border: aliases.warning.default,
      text: aliases.text.default,
      icon: aliases.text.warning,
    },
    error: {
      background: aliases.error["100"],
      border: aliases.error.default,
      text: aliases.text.default,
      icon: aliases.text.error,
    },
  },
  button: {
    default: {
      background: aliases.background.default,
      backgroundActive: aliases.background.default,
      backgroundActiveHover: aliases.highlight["200"],
      backgroundHover: aliases.background.strong,
      border: aliases.border.default,
      borderActive: aliases.highlight.default,
      borderHover: aliases.border.default,
      height: "36px",
      heightSmall: "24px",
      heightLarge: "48px",
      text: aliases.highlight.default,
      textActive: aliases.highlight.default,
    },
    highlight: {
      background: aliases.highlight.default,
      backgroundActive: aliases.background.default,
      backgroundActiveHover: aliases.highlight["200"],
      backgroundHover: aliases.highlight["700"],
      border: "transparent",
      borderActive: aliases.highlight.default,
      borderHover: "transparent",
      text: aliases.text.light,
      textActive: aliases.highlight.default,
    },
    success: {
      background: aliases.success["100"],
      backgroundActive: aliases.background.default,
      backgroundActiveHover: aliases.success["200"],
      backgroundHover: aliases.success["200"],
      border: aliases.success["300"],
      borderActive: aliases.success.default,
      borderHover: aliases.success["300"],
      text: aliases.text.success,
      textActive: aliases.text.success,
    },
    warning: {
      background: aliases.warning["100"],
      backgroundActive: aliases.background.default,
      backgroundActiveHover: aliases.warning["200"],
      backgroundHover: aliases.warning["200"],
      border: aliases.warning["300"],
      borderActive: aliases.warning.default,
      borderHover: aliases.warning["300"],
      text: aliases.text.warning,
      textActive: aliases.text.warning,
    },
    error: {
      background: aliases.error["100"],
      backgroundActive: aliases.background.default,
      backgroundActiveHover: aliases.error["200"],
      backgroundHover: aliases.error["200"],
      border: aliases.error["300"],
      borderActive: aliases.error.default,
      borderHover: aliases.error["300"],
      text: aliases.text.error,
      textActive: aliases.text.error,
    },
    overlay: {
      background: "transparent",
      backgroundActive: "transparent",
      backgroundActiveHover: `${aliases.neutral["000"]}33`,
      backgroundHover: `${aliases.neutral["000"]}33`,
      border: "transparent",
      borderHover: `${aliases.neutral["000"]}66`,
      borderActive: aliases.neutral["000"],
      text: aliases.text.light,
      textActive: aliases.text.light,
    },
    toolbar: {
      background: "transparent",
      backgroundActive: aliases.background.default,
      backgroundActiveHover: aliases.highlight["200"],
      backgroundHover: aliases.background.strong,
      border: "transparent",
      borderHover: aliases.border.default,
      borderActive: aliases.highlight.default,
      text: aliases.text.highlight,
      textActive: aliases.text.highlight,
    },
  },
  icon: {
    default: {
      fontFamily: "EDS Horizon Icons",
      size: "24px",
      sizeLarge: "48px",
      sizeSmall: "16px",
      text: aliases.text.default,
    },
  },
  input: {
    default: {
      background: aliases.background.default,
      backgroundActive: aliases.background.default,
      backgroundHover: aliases.background.default,
      backgroundReadOnly: aliases.background.strong,
      border: aliases.border.default,
      borderActive: aliases.highlight.default,
      borderHover: aliases.highlight["300"],
      height: "36px",
      text: aliases.text.default,
      underline: aliases.border.strong,
      underlineHover: aliases.highlight.default,
    },
    error: {
      background: aliases.error["100"],
      backgroundActive: aliases.background.default,
      backgroundHover: aliases.background.default,
      backgroundReadOnly: aliases.background.strong,
      border: aliases.error["300"],
      borderActive: aliases.error["500"],
      borderHover: aliases.error["300"],
      text: aliases.text.default,
      underline: aliases.error["500"],
      underlineHover: aliases.error["500"],
    },
    warning: {
      background: aliases.warning["100"],
      backgroundActive: aliases.background.default,
      backgroundHover: aliases.background.default,
      backgroundReadOnly: aliases.background.strong,
      border: aliases.warning["300"],
      borderActive: aliases.warning["500"],
      borderHover: aliases.warning["300"],
      text: aliases.text.default,
      underline: aliases.warning["500"],
      underlineHover: aliases.warning["500"],
    },
    success: {
      background: aliases.success["100"],
      backgroundActive: aliases.background.default,
      backgroundHover: aliases.background.default,
      backgroundReadOnly: aliases.background.strong,
      border: aliases.success["300"],
      borderActive: aliases.success["500"],
      borderHover: aliases.success["300"],
      text: aliases.text.default,
      underline: aliases.success["500"],
      underlineHover: aliases.success["500"],
    },
    info: {
      background: aliases.info["100"],
      backgroundActive: aliases.background.default,
      backgroundHover: aliases.background.default,
      backgroundReadOnly: aliases.background.strong,
      border: aliases.info["300"],
      borderActive: aliases.info["500"],
      borderHover: aliases.info["300"],
      text: aliases.text.default,
      underline: aliases.info["500"],
      underlineHover: aliases.info["500"],
    },
  },
  label: {
    default: {
      background: aliases.neutral["100"],
      backgroundHover: aliases.neutral["300"],
      border: aliases.border.default,
      text: aliases.text.default,
    },
    highlight: {
      background: aliases.highlight.default,
      backgroundHover: aliases.highlight["700"],
      border: aliases.highlight.default,
      text: aliases.text.light,
    },
    error: {
      background: aliases.error.default,
      backgroundHover: aliases.error["600"],
      border: aliases.error.default,
      text: aliases.text.light,
    },
    warning: {
      background: aliases.warning.default,
      backgroundHover: aliases.warning["600"],
      border: aliases.warning.default,
      text: aliases.text.light,
    },
    success: {
      background: aliases.success.default,
      backgroundHover: aliases.success["600"],
      border: aliases.success.default,
      text: aliases.text.light,
    },
  },
  link: {
    default: {
      text: aliases.text.highlight,
      textActive: aliases.highlight["300"],
      textHover: aliases.highlight["700"],
    },
    visited: {
      text: aliases.text.highlight,
      textActive: aliases.highlight["300"],
      textHover: aliases.highlight["700"],
    },
  },
  login: {
    background: `color-mix(in srgb, ${aliases.neutral["000"]} 30%, transparent)`,
    text: aliases.neutral["000"],
    backgroundDark: `color-mix(in srgb, ${aliases.neutral["800"]} 30%, transparent)`,
  },
  navigation: {
    background: aliases.background.default,
    border: aliases.border.default,
    text: aliases.text.default,
  },
  navigationItem: {
    default: {
      background: aliases.background.default,
      backgroundHover: aliases.background.strong,
      backgroundActive: aliases.highlight["200"],
      backgroundActiveHover: aliases.highlight["300"],
      marker: aliases.background.default,
      text: aliases.text.default,
    },
    selected: {
      background: aliases.background.default,
      backgroundHover: aliases.background.strong,
      backgroundActive: aliases.highlight["200"],
      backgroundActiveHover: aliases.highlight["300"],
      marker: aliases.text.highlight,
      text: aliases.text.highlight,
    },
  },
  progressBar: {
    default: {
      background: aliases.neutral["300"],
      bar: aliases.neutral.default,
    },
    inverse: {
      background: aliases.neutral["000"],
      text: aliases.neutral["000"],
    },
    notification: {
      background: aliases.neutral["100"],
      bar: aliases.highlight.default,
    },
    error: {
      background: aliases.error["200"],
      bar: aliases.error.default,
    },
    warning: {
      background: aliases.warning["200"],
      bar: aliases.warning.default,
    },
    success: {
      background: aliases.success["200"],
      bar: aliases.success.default,
    },
    info: {
      background: aliases.info["300"],
      bar: aliases.info.default,
    },
  },
  radio: {
    default: {
      background: aliases.background.strong,
      backgroundHover: aliases.background.default,
      border: aliases.border.strong,
      borderFocus: aliases.text.highlight,
      colorFocus: aliases.text.highlight,
      marker: aliases.text.highlight,
      text: aliases.text.default,
    },
    error: {
      background: aliases.error["200"],
      backgroundHover: aliases.background.default,
      border: aliases.error.default,
      borderFocus: aliases.text.error,
      colorFocus: aliases.text.error,
      marker: aliases.text.error,
      text: aliases.text.error,
    },
    info: {
      background: aliases.info["200"],
      backgroundHover: aliases.background.default,
      border: aliases.info.default,
      borderFocus: aliases.text.highlight,
      colorFocus: aliases.text.highlight,
      marker: aliases.text.highlight,
      text: aliases.text.highlight,
    },
    success: {
      background: aliases.success["200"],
      backgroundHover: aliases.background.default,
      border: aliases.success.default,
      borderFocus: aliases.text.success,
      colorFocus: aliases.text.success,
      marker: aliases.text.success,
      text: aliases.text.success,
    },
    warning: {
      background: aliases.warning["200"],
      backgroundHover: aliases.background.default,
      border: aliases.warning.default,
      borderFocus: aliases.text.warning,
      colorFocus: aliases.text.warning,
      marker: aliases.text.warning,
      text: aliases.text.warning,
    },
  },
  ruleBuilder: {
    variant1: {
      autoLabel: palette.gray["300"],
      background: palette.gray["100"],
      backgroundHover: palette.gray["200"],
      border: palette.gray["400"],
      buttonFocus: palette.gray["300"],
      buttonHover: palette.gray["400"],
      buttonTextHover: palette.gray["700"],
      text: palette.gray["500"],
    },
    variant2: {
      autoLabel: palette.blue["300"],
      background: palette.blue["100"],
      backgroundHover: palette.blue["200"],
      border: palette.blue["400"],
      buttonFocus: palette.blue["300"],
      buttonHover: palette.blue["400"],
      buttonTextHover: palette.blue["700"],
      text: palette.blue["500"],
    },
    variant3: {
      autoLabel: palette.purple["300"],
      background: palette.purple["100"],
      backgroundHover: palette.purple["200"],
      border: palette.purple["400"],
      buttonFocus: palette.purple["300"],
      buttonHover: palette.purple["400"],
      buttonTextHover: palette.purple["700"],
      text: palette.purple["500"],
    },
    wrapper: {
      backgroundHover: aliases.background.strong,
    },
  },
  separator: {
    text: aliases.text.faint,
    line: aliases.neutral["300"],
  },
  shellbar: {
    actionBackground: aliases.background.default,
    actionBackgroundHover: aliases.background.strong,
    actionText: aliases.text.default,
    background: aliases.background.default,
    text: aliases.text.default,
  },
  slider: {
    background: aliases.neutral["300"],
    bar: aliases.highlight.default,
    marker: aliases.neutral.default,
    step: aliases.neutral["300"],
    text: aliases.neutral["600"],
    handleActive: aliases.highlight.default,
    handleBackground: aliases.background.default,
    bubble: aliases.highlight.default,
    bubbleText: aliases.text.light,
  },
  switch: {
    off: {
      background: aliases.neutral.default,
      backgroundHover: aliases.neutral["600"],
      toggleText: aliases.text.default,
      toggleBackground: aliases.background.default,
      toggleBorder: aliases.border.strong,
      toggleBorderHover: aliases.outline.hover,
    },
    on: {
      background: aliases.highlight.default,
      backgroundHover: aliases.highlight["700"],
      toggleText: aliases.text.highlight,
      toggleBackground: aliases.background.default,
      toggleBorder: aliases.highlight["500"],
      toggleBorderHover: aliases.outline.hover,
    },
  },
  tab: {
    default: {
      background: aliases.background.default,
      backgroundHover: aliases.background.strong,
      marker: aliases.background.default,
      text: aliases.text.default,
    },
    selected: {
      background: aliases.background.default,
      backgroundHover: aliases.background.default,
      marker: aliases.highlight.default,
      text: aliases.text.highlight,
    },
  },
  tableCell: {
    default: {
      background: aliases.background.default,
      backgroundActive: aliases.background.strong,
      backgroundActiveHover: aliases.neutral["300"],
      backgroundHover: aliases.background.strong,
      border: aliases.border.default,
    },
    selected: {
      background: aliases.highlight["100"],
      backgroundActive: aliases.highlight["100"],
      backgroundActiveHover: aliases.highlight["200"],
      backgroundHover: aliases.highlight["200"],
      border: aliases.highlight.default,
    },
    alternate: {
      background: aliases.background.strong,
      backgroundActive: aliases.background.strong,
      backgroundActiveHover: aliases.neutral["300"],
      backgroundHover: aliases.neutral["300"],
      border: aliases.border.default,
    },
  },
});

export default tokens;
